import React, { PropTypes, Component } from 'react';
import { browserHistory } from 'react-router';
import LoadingIndicator from 'common/components/preloader';
import Deadline from 'project/containers/deadline';
import NDACheckbox from 'project/containers/nda_checkbox';
import AccessTabs from 'project/containers/access_tabs';
import Awards from 'project/containers/awards';
import Features from 'project/containers/features';
import Collaborators from 'project/containers/collaborators';
import Meta from 'project/containers/meta';

export default class Settings extends Component {
  componentDidMount() {
    const {
      userId, project, fetchNDAs, goToEntries, fetchInvites, fetchRemoved,
      fetchCollaborators, fetchParticipants
    } = this.props;

    if (userId !== project.client) {
      goToEntries();
    }

    fetchNDAs();
    fetchInvites();
    fetchRemoved();
    fetchCollaborators();
    fetchParticipants();

    this.redirectToFirstAccessLink();
  }

  componentDidUpdate() {
    this.redirectToFirstAccessLink();
  }

  redirectToFirstAccessLink() {
    /* redirect to first access tab link if there's any and if user is at settings root */
    const { accessTabs, currentURL } = this.props;
    const atRoot = currentURL.endsWith('/settings') || currentURL.endsWith('/settings/');
    if (accessTabs.links.length > 0 && atRoot) {
      browserHistory.push(accessTabs.links[0].url);
    }
  }

  render() {
    const {
      isLoading, projectId, children, project, accessTabs,
    } = this.props;

    if (isLoading) {
      return (<LoadingIndicator />);
    }

    return (<div>
      <Meta title="Settings" />
      <div className="row">
        <div className="small-16 medium-12 columns">
          {accessTabs.links.length > 0 &&
            <div className="row">
              <div className="small-10 medium-16 columns">
                <h3 className="section-header">Access</h3>
              </div>

              <div className="small-6 medium-16 column">
                <AccessTabs projectId={projectId} tabs={accessTabs} />
              </div>

              {project.nda_required && project.nda_manual_approval_allowed &&
              <div className="small-16 column">
                <NDACheckbox projectId={projectId} />
              </div>}

              <div className="tab-content">
                { children }
              </div>
            </div>
          }
          <div className="row">
            <Collaborators projectId={projectId} project={project} />
          </div>
        </div>
        <div className="small-16 medium-4 column">
          <Deadline />
          <Awards />
          <Features />
        </div>
      </div>
    </div>);
  }
}

Settings.propTypes = {
  fetchNDAs: PropTypes.func.isRequired,
  fetchInvites: PropTypes.func.isRequired,
  fetchRemoved: PropTypes.func.isRequired,
  fetchCollaborators: PropTypes.func.isRequired,
  fetchParticipants: PropTypes.func.isRequired,
  goToEntries: PropTypes.func.isRequired,
  userId: PropTypes.any,
  project: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  children: PropTypes.any,
  projectId: PropTypes.number.isRequired,
  accessTabs: PropTypes.object.isRequired,
  currentURL: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/project_settings.jsx